import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PagesGuard  {
  canActivate(): boolean {
    return true
  }
}
